<template>
	<v-container>
		<v-row>
			<v-col cols="12" class="text-h6">Documentos</v-col>
			<v-col v-if="hasTypeDocuments">
				<div class="text--secondary caption">
					Estos documentos han sido solicitados por un administrador*
				</div>
				<v-card outlined>
					<v-row justify="center">
						<v-col v-if="person.typeDocument.length" cols="12" md="6">
							<v-alert
								v-if="
									person.documents.some(item => {
										if (item && item.date) return itsDue(item.date);
									})
								"
								dense
								text
								type="error"
							>
								<strong>{{ person.firstName }}</strong> Tiene algun(os) documento(s)
								<strong>Caducado</strong>
							</v-alert>
							<template v-else>
								<v-alert
									v-if="
										Array.isArray(person.typeDocument) &&
											person.typeDocument.length &&
											person.typeDocument.some(
												typeDocument =>
													typeDocument && typeDocument.done == false
											)
									"
									dense
									text
									type="warning"
								>
									<strong>{{ person.firstName }}</strong> Tiene documento(s)
									<strong>pendiente</strong>
								</v-alert>
								<v-alert v-else dense text type="success">
									<strong>{{ person.firstName }}</strong> Todo sus documentos
									<strong>Al día</strong>
								</v-alert>
							</template>
						</v-col>
					</v-row>
					<v-card-text class="pa-0">
						<v-slide-group
							v-model="slide"
							class="py-4 px-0"
							mandatory
							center-active
							show-arrows
						>
							<div
								v-for="(item, i) in person.typeDocument"
								:key="i"
								@click="selected = i"
							>
								<v-slide-item v-if="item" v-slot="{ toggle }">
									<v-card
										v-if="person.documents[i]"
										class="ma-4"
										height="220"
										:width="$vuetify.breakpoint.lgAndUp ? '250' : '200'"
										@click="toggle"
									>
										<v-list-item
											:class="
												itsDue(person.documents[i].date)
													? 'error'
													: 'success'
											"
											dark
										>
											<v-list-item-content>
												<v-list-item-title class="headline">
													{{ person.documents[i].type }}
													<span>
														<v-icon
															dark
															small
															v-if="itsDue(person.documents[i].date)"
														>
															mdi-clock-alert
														</v-icon>
														<v-icon dark small v-else>
															mdi-checkbox-marked-circle
														</v-icon>
													</span>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-card-text style="height: 120px">
											<div
												v-if="itsDue(person.documents[i].date)"
												style="font-size: 8pt; height: 40px"
											>
												Caducado el
												{{ changeFormat(person.documents[i].date) }}
											</div>
											<div v-else style="font-size: 8pt;height: 60px">
												Creado:
												{{ createAt(person.documents[i].createdAt) }}
												{{
													person.documents[i].date &&
														`- Vence: ${changeFormat(
															person.documents[i].date
														)}`
												}}
												<br />
												(
												{{ getOffDays(person.documents[i].date) }}

												<template
													v-if="
														getOffDays(person.documents[i].date) !=
															'Sin vencimiento )'
													"
												>
													<span
														v-if="
															getOffDays(person.documents[i].date) ==
																'1'
														"
													>
														día)</span
													>
													<span v-else>dias)</span>
												</template>
											</div>
											<div
												class="headline"
												:class="
													itsDue(person.documents[i].date)
														? 'error--text'
														: 'success--text'
												"
											>
												{{
													itsDue(person.documents[i].date)
														? 'Caducado'
														: 'Al día'
												}}
											</div>
										</v-card-text>
										<v-card-actions v-if="person.documents[i].url">
											<v-spacer></v-spacer>
											<v-btn
												color="success"
												small
												:href="person.documents[i].url"
												target="_blank"
											>
												descargar
												<v-icon right>mdi-download</v-icon>
											</v-btn>
											<v-spacer></v-spacer>
										</v-card-actions>
									</v-card>
									<v-card
										v-else
										class="ma-4"
										height="220"
										width="250"
										@click="toggle"
									>
										<v-list-item two-line class="warning" dark>
											<v-list-item-content>
												<v-list-item-title class="headline">
													{{ item.type }}
													<v-icon small color="white">
														mdi-file-question
													</v-icon>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-card-text>
											<div class="headline warning--text pt-8">
												Pendiente
											</div>
										</v-card-text>
									</v-card>
								</v-slide-item>
							</div>
						</v-slide-group>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" v-else>
				<data-empty height="120" msj="No tiene documentos para mostrar" />
			</v-col>
			<v-col cols="12">
				<v-expand-transition>
					<v-row
						v-if="
							person && person.typeDocument && Boolean(person.typeDocument[selected])
						"
					>
						<v-col cols="12" md="5">
							<v-file-input
								id="uploads"
								v-model="documents"
								:disabled="loadingDocuments"
								outlined
								:label="
									person.documents[selected]
										? person.documents[selected].type
										: person.typeDocument[selected].type
								"
								filled
								dense
								single-line
							/>
						</v-col>
						<v-col cols="12" md="5">
							<v-menu
								ref="menu"
								v-model="menu"
								:close-on-content-click="false"
								:return-value.sync="date"
								transition="scale-transition"
								offset-y
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="date"
										dense
										filled
										readonly
										clearable
										outlined
										placeholder="*opcional"
										label="Fecha de vencimiento"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="date"
									outlined
									locale="es"
									no-title
									scrollable
								>
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="menu = false"
										>Cancelar</v-btn
									>
									<v-btn text color="primary" @click="$refs.menu.save(date)"
										>OK</v-btn
									>
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="2" class="mt-2">
							<v-btn
								block
								:loading="loadingDocuments"
								small
								color="primary"
								@click="uploadDocument"
							>
								Subir
							</v-btn>
						</v-col>
					</v-row>
				</v-expand-transition>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			loadingDocuments: false,
			documents: null,
			selected: null,
			slide: null,
			date: null,
			menu: false,
		};
	},
	computed: {
		hasTypeDocuments() {
			return (
				this.person &&
				this.person.typeDocument &&
				this.person.typeDocument.length &&
				this.person.typeDocument.some(typeDocument => typeDocument)
			);
		},
		...mapGetters({ person: 'Person/person' }),
	},
	methods: {
		async uploadDocument() {
			if (!this.documents) return;
			this.loadingDocuments = true;
			let data = {
				_id: this.person._id,
				documents: this.documents,
				typeDocument: [...this.person.typeDocument],
			};

			data.typeDocument[this.selected] = {
				...data.typeDocument[this.selected],
				done: true,
				isEditing: true,
				date: this.date,
			};

			const person = await this.upload(data);
			this.setPerson(person);
			this.setDocumentBadge();
			this.documents = null;
			this.date = null;
			this.loadingDocuments = false;
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		changeFormat(date) {
			return moment(date).format('DD-MM-YYYY');
		},
		getOffDays(date) {
			if (date == null) return 'Sin vencimiento )';
			let now = moment().format('YYYY-MM-DD');
			return moment(date).diff(now, 'days');
		},
		createAt(createdAt) {
			if (createdAt) return moment(createdAt).format('l');
			else return 'Sin fechas';
		},
		...mapMutations({
			setPerson: 'Person/setPerson',
			setDocumentBadge: 'Person/setDocumentBadge',
		}),
		...mapActions({ upload: 'Person/upload' }),
	},
};
</script>

<style lang="scss" scoped></style>
